import Slideout from 'slideout';
import velocity from 'velocity-animate';

$.fn.velocity = velocity;
console.log('intertn template geladen');


var slideout = new Slideout({
    'panel': $('.mainwrap').get(0),
    'menu': $('.sf-menu').get(0),
    'padding': 250,
    'tolerance': 70
});
$('.toggle-button').on('click', function() {
    slideout.toggle();
});

const navAnimDur = 250;
// accordeon basic script
let aTrig = $('.accTrigger'),
    aTopTrig = $('.accTopTrigger');

$('.accCont').velocity("slideUp", { duration: 0 });
aTrig.prepend('<i class="accicon material-icons">expand_more</i>');


aTrig.on('click',function(){
    var selfCont = $(this).next('.accCont'),
        self= $(this).parent('.drawer');
    if(!self.hasClass('open')){
        self.addClass('open');
        selfCont.velocity("slideDown", { duration: navAnimDur });
    }else{
        self.removeClass('open');
        selfCont.velocity("slideUp", { duration: navAnimDur });
    }
});

aTopTrig.on('click', function(){
    var selfCont = $(this).prev('.accCont'),
        self= $(this).parent('.drawerToTop');
    if(!self.hasClass('open')){
        self.addClass('open');
        selfCont.velocity("slideDown", { duration: navAnimDur });
    }else{
        self.removeClass('open');
        selfCont.velocity("slideUp", { duration: navAnimDur });
    }
});


// WEBPACK FOOTER //
// ./js/interntemplatescript.js